import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  groupOrdersCount: {
    description: 'Total Orders in Group',
    defaultMessage: '{totalCount} Orders',
    id: 'kymxUi',
  },
  groupOrdersSelectedCount: {
    description: 'Total Orders Selected in Group',
    defaultMessage: 'Selected {selectedCount} of {totalCount} Orders',
    id: 'kQ5K7u',
  },
  groupOrdersSelectAll: {
    description: 'Select all orders in group action text',
    defaultMessage: 'Select all {totalCount} orders in the Group',
    id: 'DsuBtS',
  },
  groupOrdersMoreOptions: {
    description: 'Group Action Text',
    defaultMessage: 'More Actions...',
    id: 'FHOtUX',
  },
  groupOrdersNewView: {
    description: 'Group Action Text - New View',
    defaultMessage: 'Open as a New View...',
    id: '4+fu00',
  },
  groupOrdersAddToBatch: {
    description: 'Group Action Text - Add To Batch',
    defaultMessage: 'Add to Batch...',
    id: 'ZIhl5+',
  },
  none: {
    description: 'Groupby Details Meta Text - None',
    defaultMessage: 'None',
    id: 'j7Ntj3',
  },
});
